import React from 'react'
import './animatedBrandMark.css'
import octopusMark from '../assets/home/octopus-mark.png'

const AnimatedBrandMark = ({ variant = 'default', className = '' }) => {
  const classes = [
    'octo-brand-mark',
    variant !== 'default' && `octo-brand-mark--${variant}`,
    className,
  ].filter(Boolean).join(' ')

  return (
    <span
      className={classes}
      data-animated-brand-mark=""
      data-final-cta-icon={variant === 'cta' ? 'reactivation' : undefined}
      aria-hidden="true"
    >
      <span
        className="octo-brand-mark__orbit octo-brand-mark__orbit--outer"
        data-brand-mark-motion="outer-orbit"
      />
      <span
        className="octo-brand-mark__orbit octo-brand-mark__orbit--inner"
        data-brand-mark-motion="inner-orbit"
      />
      <img
        src={octopusMark}
        alt=""
        width="160"
        height="160"
        decoding="async"
        data-brand-mark-core=""
      />
    </span>
  )
}

export default AnimatedBrandMark
